import { useEffect } from "react";
import { useUrlParamsContext, useTheme } from "src/contexts";

export const useThemeInitializer = () => {
  const { theme: urlTheme } = useUrlParamsContext();
  const { onSetTheme } = useTheme();

  useEffect(() => {
    if (urlTheme) {
      onSetTheme(urlTheme);
    }
  }, [urlTheme, onSetTheme]);
};
